import { msg } from "@lit/localize";
import { APPS } from "./constants.js";
export const SHORTCUT_SECTIONS = {
    BASIC: "basic",
    BUBBLY: "bubbly",
    DEFAULT: "default",
    PRESENTATION: "presentation",
    TEXT_EDITOR: "text_editor",
    SCRIPT_EDITOR: "script_editor",
    SCHEDULER: "scheduler",
};
const { BASIC, BUBBLY, PRESENTATION, TEXT_EDITOR, SCRIPT_EDITOR, SCHEDULER } = SHORTCUT_SECTIONS;
export const sectionOrder = {
    default: [BASIC, BUBBLY],
    projects: [BASIC, TEXT_EDITOR, SCHEDULER],
    results: [BASIC, PRESENTATION, TEXT_EDITOR],
    robotics: [BASIC, SCRIPT_EDITOR],
    storyboards: [BASIC, PRESENTATION, TEXT_EDITOR],
};
export const DELIMITERS = {
    COMMA: "COMMA",
    PLUS: "PLUS",
    BACKSLASH: "BACKSLASH",
};
export const macShortcutKeys = {
    [BASIC]: {
        KEYBOARD_SHORTCUT: ["metaKey", DELIMITERS.PLUS, "/"],
        DISMISS: ["esc"],
    },
    [PRESENTATION]: {
        NEXT_SLIDE: ["space", DELIMITERS.COMMA, "arrowright"],
        PREV_SLIDE: ["arrowleft"],
        FIRST_SLIDE: ["home"],
        LAST_SLIDE: ["end"],
        FULLSCREEN: ["f"],
        SLIDE_OVERVIEW: ["o"],
    },
    [TEXT_EDITOR]: {
        BOLD: ["metaKey", DELIMITERS.PLUS, "b"],
        ITALIC: ["metaKey", DELIMITERS.PLUS, "i"],
        UNDERLINE: ["metaKey", DELIMITERS.PLUS, "u"],
        SELECT_ALL: ["metaKey", DELIMITERS.PLUS, "a"],
        REDO: ["metaKey", DELIMITERS.PLUS, "shiftKey", DELIMITERS.PLUS, "z"],
        UNDO: ["metaKey", DELIMITERS.PLUS, "z"],
    },
    [SCHEDULER]: {
        HIGHLIGHT_ROW: ["space"],
        OPEN_SIDEPANEL: ["enter"],
        EXPAND_ROW: ["shiftKey", DELIMITERS.PLUS, "arrowright"],
        COLLAPSE_ROW: ["shiftKey", DELIMITERS.PLUS, "arrowleft"],
        SCROLL_UP: ["optionKey", DELIMITERS.PLUS, "arrowup"],
        SCROLL_DOWN: ["optionKey", DELIMITERS.PLUS, "arrowdown"],
        SCROLL_LEFT: ["optionKey", DELIMITERS.PLUS, "arrowleft"],
        SCROLL_RIGHT: ["optionKey", DELIMITERS.PLUS, "arrowright"],
    },
    [SCRIPT_EDITOR]: {
        RUN: ["metaKey", DELIMITERS.PLUS, "shiftKey", DELIMITERS.PLUS, "enter"],
        RUN_ALL: ["metaKey", DELIMITERS.PLUS, "shiftKey", DELIMITERS.PLUS, "m"],
        RUN_THIS_AND_ABOVE: ["metaKey", DELIMITERS.PLUS, "shiftKey", DELIMITERS.PLUS, "y"],
        RUN_THIS_AND_BELOW: ["metaKey", DELIMITERS.PLUS, "shiftKey", DELIMITERS.PLUS, "u"],
        STOP: ["metaKey", DELIMITERS.PLUS, "shiftKey", DELIMITERS.PLUS, "i"],
        CELL_ABOVE: [
            "metaKey",
            DELIMITERS.PLUS,
            "shiftKey",
            DELIMITERS.PLUS,
            "arrowup",
            DELIMITERS.BACKSLASH,
            "k",
        ],
        CELL_BELOW: [
            "metaKey",
            DELIMITERS.PLUS,
            "shiftKey",
            DELIMITERS.PLUS,
            "arrowdown",
            DELIMITERS.BACKSLASH,
            "j",
        ],
        FIRST_CELL: [
            "metaKey",
            DELIMITERS.PLUS,
            "shiftKey",
            DELIMITERS.PLUS,
            "home",
            DELIMITERS.BACKSLASH,
            "h",
        ],
        LAST_CELL: [
            "metaKey",
            DELIMITERS.PLUS,
            "shiftKey",
            DELIMITERS.PLUS,
            "end",
            DELIMITERS.BACKSLASH,
            "l",
        ],
        ADD_CELL: ["metaKey", DELIMITERS.PLUS, "shiftKey", DELIMITERS.PLUS, "b"],
        DELETE_CELL: ["metaKey", DELIMITERS.PLUS, "shiftKey", DELIMITERS.PLUS, "d"],
        MOVE_CELL_UP: ["metaKey", DELIMITERS.PLUS, "shiftKey", DELIMITERS.PLUS, "z"],
        MOVE_CELL_DOWN: ["metaKey", DELIMITERS.PLUS, "shiftKey", DELIMITERS.PLUS, "x"],
    },
};
export const winShortcutKeys = {
    [BASIC]: {
        KEYBOARD_SHORTCUT: ["ctrlKey", DELIMITERS.PLUS, "/"],
        DISMISS: ["esc"],
    },
    [PRESENTATION]: {
        NEXT_SLIDE: ["space", DELIMITERS.COMMA, "arrowright"],
        PREV_SLIDE: ["arrowleft"],
        FIRST_SLIDE: ["home"],
        LAST_SLIDE: ["end"],
        FULLSCREEN: ["f"],
        SLIDE_OVERVIEW: ["o"],
    },
    [TEXT_EDITOR]: {
        BOLD: ["ctrlKey", DELIMITERS.PLUS, "b"],
        ITALIC: ["ctrlKey", DELIMITERS.PLUS, "i"],
        UNDERLINE: ["ctrlKey", DELIMITERS.PLUS, "u"],
        SELECT_ALL: ["ctrlKey", DELIMITERS.PLUS, "a"],
        REDO: ["ctrlKey", DELIMITERS.PLUS, "shiftKey", DELIMITERS.PLUS, "z"],
        UNDO: ["ctrlKey", DELIMITERS.PLUS, "z"],
    },
    [SCHEDULER]: {
        HIGHLIGHT_ROW: ["space"],
        OPEN_SIDEPANEL: ["enter"],
        EXPAND_ROW: ["shiftKey", DELIMITERS.PLUS, "arrowright"],
        COLLAPSE_ROW: ["shiftKey", DELIMITERS.PLUS, "arrowleft"],
        SCROLL_UP: ["altKey", DELIMITERS.PLUS, "arrowup"],
        SCROLL_DOWN: ["altKey", DELIMITERS.PLUS, "arrowdown"],
        SCROLL_LEFT: ["altKey", DELIMITERS.PLUS, "arrowleft"],
        SCROLL_RIGHT: ["altKey", DELIMITERS.PLUS, "arrowright"],
    },
    [SCRIPT_EDITOR]: {
        RUN: ["ctrlKey", DELIMITERS.PLUS, "shiftKey", DELIMITERS.PLUS, "enter"],
        RUN_ALL: ["ctrlKey", DELIMITERS.PLUS, "shiftKey", DELIMITERS.PLUS, "m"],
        RUN_THIS_AND_ABOVE: ["ctrlKey", DELIMITERS.PLUS, "shiftKey", DELIMITERS.PLUS, "y"],
        RUN_THIS_AND_BELOW: ["ctrlKey", DELIMITERS.PLUS, "shiftKey", DELIMITERS.PLUS, "u"],
        STOP: ["ctrlKey", DELIMITERS.PLUS, "shiftKey", DELIMITERS.PLUS, "i"],
        CELL_ABOVE: [
            "ctrlKey",
            DELIMITERS.PLUS,
            "shiftKey",
            DELIMITERS.PLUS,
            "arrowup",
            DELIMITERS.BACKSLASH,
            "k",
        ],
        CELL_BELOW: [
            "ctrlKey",
            DELIMITERS.PLUS,
            "shiftKey",
            DELIMITERS.PLUS,
            "arrowdown",
            DELIMITERS.BACKSLASH,
            "j",
        ],
        FIRST_CELL: [
            "ctrlKey",
            DELIMITERS.PLUS,
            "shiftKey",
            DELIMITERS.PLUS,
            "home",
            DELIMITERS.BACKSLASH,
            "h",
        ],
        LAST_CELL: [
            "ctrlKey",
            DELIMITERS.PLUS,
            "shiftKey",
            DELIMITERS.PLUS,
            "end",
            DELIMITERS.BACKSLASH,
            "l",
        ],
        ADD_CELL: ["ctrlKey", DELIMITERS.PLUS, "shiftKey", DELIMITERS.PLUS, "b"],
        DELETE_CELL: ["ctrlKey", DELIMITERS.PLUS, "shiftKey", DELIMITERS.PLUS, "d"],
        MOVE_CELL_UP: ["ctrlKey", DELIMITERS.PLUS, "shiftKey", DELIMITERS.PLUS, "z"],
        MOVE_CELL_DOWN: ["ctrlKey", DELIMITERS.PLUS, "shiftKey", DELIMITERS.PLUS, "x"],
    },
    [BUBBLY]: {},
};
export const commandLabels = {
    KEYBOARD_SHORTCUT: () => msg(`Keyboard shortcuts`),
    DISMISS: () => msg(`Close dialogs`),
    NEXT_SLIDE: () => msg(`Next slide`),
    PREV_SLIDE: () => msg(`Previous slide`),
    FIRST_SLIDE: () => msg(`First slide`),
    LAST_SLIDE: () => msg(`Last slide`),
    FULLSCREEN: () => msg(`Fullscreen`),
    SLIDE_OVERVIEW: () => msg(`Slide overview`),
    BOLD: () => msg(`Bold`),
    ITALIC: () => msg(`Italic`),
    UNDERLINE: () => msg(`Underline`),
    SELECT_ALL: () => msg(`Select all`),
    REDO: () => msg(`Redo`),
    UNDO: () => msg(`Undo`),
    HIGHLIGHT_ROW: () => msg(`Highlight a row`),
    OPEN_SIDEPANEL: () => msg(`Open a sidepanel`),
    EXPAND_ROW: () => msg(`Expand the current row`),
    COLLAPSE_ROW: () => msg(`Collapse the current row`),
    SCROLL_UP: () => msg(`Scroll up`),
    SCROLL_DOWN: () => msg(`Scroll down`),
    SCROLL_LEFT: () => msg(`Scroll left`),
    SCROLL_RIGHT: () => msg(`Scroll right`),
    RUN: () => msg(`Run selected cell`),
    RUN_ALL: () => msg(`Run all cells sequentially`),
    RUN_THIS_AND_ABOVE: () => msg(`Run this and all the cells above`),
    RUN_THIS_AND_BELOW: () => msg(`Run this and all the cells below`),
    STOP: () => msg(`Stop execution`),
    CELL_ABOVE: () => msg(`Select cell above`),
    CELL_BELOW: () => msg(`Select cell below`),
    FIRST_CELL: () => msg(`Select first cell`),
    LAST_CELL: () => msg(`Select last cell`),
    ADD_CELL: () => msg(`Add cell below`),
    DELETE_CELL: () => msg(`Delete selected cell`),
    MOVE_CELL_UP: () => msg(`Move cell up`),
    MOVE_CELL_DOWN: () => msg(`Move cell down`),
};
export const sectionLabels = {
    [BASIC]: () => msg(`Basic`),
    [PRESENTATION]: () => msg(`Presentation`),
    [TEXT_EDITOR]: () => msg(`Text editor`),
    [SCHEDULER]: APPS.PROJECT_SCHEDULER.label,
    [SCRIPT_EDITOR]: () => msg(`Robots script editor`),
};
export const shortcutKeyLabels = {
    esc: () => msg(`Esc`, { desc: "Keyboard key" }),
    enter: () => msg(`Enter`, { desc: "Keyboard key" }),
    home: () => msg(`Home`, { id: "shortcuts-home", desc: "Keyboard key" }),
    end: () => msg(`End`, { desc: "Keyboard key" }),
    space: () => msg(`Space`, { desc: "Keyboard key" }),
    shiftKey: () => msg(`Shift`, { desc: "Keyboard key" }),
    altKey: () => msg(`Alt`, { desc: "Keyboard key" }),
    optionKey: () => msg(`Option`, { desc: "Keyboard key" }),
    ctrlKey: () => msg(`Ctrl`, { desc: "Keyboard key" }),
    arrowup: () => msg(`Up arrow`, { desc: "Keyboard key" }),
    arrowdown: () => msg(`Down arrow`, { desc: "Keyboard key" }),
    arrowleft: () => msg(`Left arrow`, { desc: "Keyboard key" }),
    arrowright: () => msg(`Right arrow`, { desc: "Keyboard key" }),
};
